import { render, staticRenderFns } from "./IntertelUC.vue?vue&type=template&id=e9f04d02&scoped=true&"
import script from "./IntertelUC.vue?vue&type=script&lang=js&"
export * from "./IntertelUC.vue?vue&type=script&lang=js&"
import style0 from "./IntertelUC.vue?vue&type=style&index=0&id=e9f04d02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f04d02",
  null
  
)

export default component.exports